import {
  isAuthenticatedUserContext,
  useMaybeUserContext,
} from '@/contexts/user-context';
import { LineItemNotesAccessMode } from '@/contexts/dynamic-config';
import { useDynamicConfigValue } from '@/hooks/use-dynamic-config-value';

/**
 * Whether the current user can write/request line item notes.
 * Uses dynamic config line_item_notes_config (backend LineItemNotesConfig).
 * - ALL: true for everyone (default).
 * - DSR_ONLY: true only when the user is a supplier employee (supplierEmployeeRole != null).
 */
export const useCanWriteLineItemRequest = (): boolean => {
  const accessMode =
    useDynamicConfigValue('line_item_notes_config')?.access_mode ||
    LineItemNotesAccessMode.ALL;

  const context = useMaybeUserContext();

  if (accessMode === LineItemNotesAccessMode.DSR_ONLY) {
    return (
      isAuthenticatedUserContext(context) &&
      context.supplierEmployeeRole !== null
    );
  }
  return true;
};
